export default "icons-credit"